import Big from 'big.js';

export const formatNumber = number => {
  return `${number ?? ''}`.replace('.', ',').replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
};

export const formatMoney = (amount, decimals = 2, currency = '€') => {
  const _amount = new Big(amount ?? 0);
  return `${_amount.toFixed(decimals)}${currency}`;
  //return `${formatNumber(_amount.toFixed(decimals))}${currency}`; // used to format as X.XXX,YY
};

export const convertFromCents = amount => {
  if (!!amount) {
    return new Big(amount).div(100).toNumber();
  }
  return 0;
};
